import { m } from "framer-motion";

import { ANIMATE_DEFAULT_PROPS, ANIMATE_DISPLAY_NAME_PROPS } from '../../constants';
import { SLIDER } from '../../../../constants'
import { AdsBannerCardButtons } from './adsBannerCardButtons'
import { AdsBannerCardImage } from './adsBannerCardImage'
import { PriceComponent } from "../../../home/price";

export const AdsBannerCard = ({ product = {}, ybAdsPageData = {}, scrollPosition, googleAnalytics }) => {
    const subHeading = product?.subHeading
    const productName = product?.displayName
    const productOSR = product?.productOsr
    const productActionURL = product?.actionUrl
    const shouldDisplayPrice = product !== undefined && Object.keys(product).length > 0

    const bannerButtons = Object.keys(ybAdsPageData)?.length > 0 && ybAdsPageData.ybProductBrowseAds?.map((adsButton, key) => {
        const productOsrs = adsButton.ctaCheck?.productOsr?.split(",");
        const isSingleProductOSR = productOsrs?.length === 1 && adsButton.ctaCheck?.productOsr === productOSR

        if (isSingleProductOSR) return (
            <AdsBannerCardButtons
                key={`${adsButton.ctaCheck?.productOsr}-${key}`}
                productURL={productActionURL}
                productButtonName={adsButton?.ctaButton}
                googleAnalytics={googleAnalytics}
            />
        )

        return (
            <>
                {
                    productOsrs?.length > 1 && productOsrs.map((osrValue, key) => {
                        if (osrValue === productOSR) return (
                            <AdsBannerCardButtons
                                key={`${osrValue}-${key}`}
                                productURL={productActionURL}
                                productButtonName={adsButton?.ctaButton}
                                googleAnalytics={googleAnalytics}
                            />
                        )

                        return true
                    })
                }
            </>
        )
    })

    const bannerImage = Object.keys(ybAdsPageData)?.length > 0 && ybAdsPageData.ybProductBrowseAds?.map((adsImage, key) => {
        const productOsrs = adsImage.ctaCheck?.productOsr?.split(",");
        if (productOsrs?.length === 1 && adsImage.ctaCheck?.productOsr === product.productOsr) {
            return (
                <AdsBannerCardImage
                    key={`${adsImage.ctaCheck?.productOsr}-${key}`}
                    productName={productName}
                    productURL={productActionURL}
                    productImageURL={product?.imageUrl}
                    desktopImageUrl={adsImage.desktopImageUrl}
                    mobileImageUrl={adsImage.mobileImageUrl}
                    scrollPosition={scrollPosition}
                    googleAnalytics={googleAnalytics}
                />
            )
        } else {
            return (
                <>
                    {
                        productOsrs?.length > 1 && productOsrs.map((osrValue, key) => {
                            if (osrValue === product.productOsr) return (
                                <AdsBannerCardImage
                                    key={`${osrValue}-${key}`}
                                    productName={productName}
                                    productURL={productActionURL}
                                    productImageURL={product?.imageUrl}
                                    desktopImageUrl={adsImage.desktopImageUrl}
                                    mobileImageUrl={adsImage.mobileImageUrl}
                                    scrollPosition={scrollPosition}
                                    googleAnalytics={googleAnalytics}
                                />
                            )

                            return true
                        })
                    }
                </>)
        }
    })

    return (
        <m.div className="product" variants={SLIDER.PRODUCT}>
            <div className="ads-banner">
                <m.div className="overlay" animate={ANIMATE_DEFAULT_PROPS}>
                    <div className="inner">
                        <div>
                            <m.h2 className="my-3" animate={ANIMATE_DISPLAY_NAME_PROPS}>{productName}</m.h2>
                            {subHeading && <p>{subHeading}</p>}
                            {shouldDisplayPrice && (
                                <div className="price-label my-3">
                                    <PriceComponent data={product} />
                                </div>
                            )}
                            {bannerButtons}
                        </div>
                    </div>

                </m.div>
                {bannerImage}
            </div>

        </m.div>)
}